import 'v-calendar/dist/style.css'
import { DatePicker } from 'v-calendar'

export default function (app: any) {
  app.component('DatePicker', DatePicker)
}
